import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Popup } from "@/Common/Components/Modals/Popup";

interface WorkSafeBcInvalidFieldsPopupProps {
    onCreateClaim: () => void;
    onClose: () => void;
}

class WorkSafeBcInvalidFieldsPopup extends BaseReactComponent<WorkSafeBcInvalidFieldsPopupProps> {
    public render(): JSX.Element {
        return (
            <Popup
                title={this.getString("WarningLabel")}
                manageOverlay
                width={450}
                onCloseDelegate={() => this.props.onClose()}
                standardFooterProps={{
                    cancelButton: {
                        label: cacheStore.GetString("BackToNoteLabel")
                    },
                    okButton: {
                        label: cacheStore.GetString("CreateClaimLabel"),
                        onClick: () => {
                            this.props.onClose();
                            this.props.onCreateClaim();
                        }
                    }
                }}
            >
                <p className="padding-md">
                    {this.getString("WorkSafeBc_InvalidFieldsWarning")}
                </p>
            </Popup>
        );
    }
}

export { WorkSafeBcInvalidFieldsPopup };
